const PERKS_PANEL_UUID = 'b8e1929a-b01f-4d54-b259-7daee08f155a';

export function isOnboardingPanel(panelUuid: string) {
  return panelUuid === PERKS_PANEL_UUID;
}
